function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cf5285;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15.964,14.714a6.443,6.443,0,1,0-9.359,0,5.525,5.525,0,0,1,9.359,0ZM7.957,16.069,11.284,19.4l3.328-3.327a3.682,3.682,0,0,0-6.655,0ZM11.284,22,5.426,16.142a8.284,8.284,0,1,1,11.716,0Zm0-12.636a.92.92,0,1,0-.92-.92A.92.92,0,0,0,11.284,9.364Zm0,1.841a2.761,2.761,0,1,1,2.761-2.761A2.761,2.761,0,0,1,11.284,11.2Z",
  transform: "translate(-3 -2)"
});

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.569,
    height: 20,
    viewBox: "0 0 16.569 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.ae14f14e44553ac21e4ff8a05b878a91.svg";
export { ForwardRef as ReactComponent };